module.exports = __webpack_public_path__ + "static/media/mail.0dfa5ebe.svg";